import React from 'react';
import { X, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const comparisonData = [{
    bad: 'No-show crews',
    good: 'We show up — every time'
  }, {
    bad: 'Hidden fees & surprise charges',
    good: 'Clear pricing upfront, always'
  }, {
    bad: 'Different person every week',
    good: 'Same reliable team you know'
  }, {
    bad: 'Rushed, half-finished work',
    good: 'Done right or we make it right'
  }, {
    bad: 'Zero communication',
    good: 'Fast response, real accountability'
  }, {
    bad: 'One-and-done service',
    good: 'Long-term care you can count on'
  }];
  return <section className="py-14 bg-white" data-id="element-173">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-175">
          

          
        </div>
      </div>
    </section>;
}